import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface CampaignEmailPreviewData {
  subject: string;
  fromEmail: string;
  body: string;
}

@Component({
  selector: 'app-campaign-email-preview-dialog',
  templateUrl: './campaign-email-preview-dialog.component.html',
  styleUrls: ['./campaign-email-preview-dialog.component.scss']
})
export class CampaignEmailPreviewDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<CampaignEmailPreviewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CampaignEmailPreviewData,
  ) { }
}